import React, { useState, useCallback } from 'react';
import { useSpring, animated } from 'react-spring';
import useDark from 'use-dark';
// import useDark from '../use-dark-link';

import imgSrc from '../assets/dark.jpg';
import img2Src from '../assets/dark2.jpg';
import img3Src from '../assets/dark4.jpg';

const slides = [
  {
    dark: {
      image: imgSrc,
      type: 3,
      speed: 0.3,
      responsive: [
        [600, 1],
        [800, 2],
      ],
    },
    data: {
      text: 'USE DARK',
      subtext: (
        <span>
          canvas based{' '}
          <a
            href="https://www.npmjs.com/package/use-dark"
            target="_blank"
            rel="noopener noreferrer"
          >
            react hook
          </a>
        </span>
      ),
    },
  },
  {
    dark: {
      image: img2Src,
      type: 3,
      speed: 0.4,
      responsive: [
        [600, 1],
        [800, 2],
      ],
    },
    data: {
      text: 'CUSTOMIZE',
      subtext: <span>images, speed, reflections</span>,
    },
  },
  {
    dark: {
      image: img3Src,
      type: 3,
      speed: 0.2,
      responsive: [
        [600, 1],
        [800, 2],
      ],
    },
    data: {
      text: 'INSTALL',
      subtext: (
        <span>
          npm install{' '}
          <a
            href="https://www.npmjs.com/package/use-dark"
            target="_blank"
            rel="noopener noreferrer"
          >
            use-dark
          </a>
        </span>
      ),
    },
  },
  {
    dark: {
      image: 'https://source.unsplash.com/H29hlvn9jyE/640x906',
      type: 4,
      speed: 0.2,
      responsive: [
        [600, 1],
        [800, 2],
      ],
    },
    data: {
      text: 'CODE',
      subtext: (
        <span>
          star on{' '}
          <a
            href="https://github.com/nikpundik/use-dark"
            target="_blank"
            rel="noopener noreferrer"
          >
            github
          </a>
        </span>
      ),
    },
  },
];

function DarkSprings() {
  const [slide, setSlide] = useState({
    index: 0,
    data: {},
    dark: slides[0].dark,
  });
  const [fading, setFading] = useState(true);
  const props = useSpring({ opacity: fading ? 0 : 1 });

  const onFadeOut = useCallback(() => {
    setFading(true);
  }, []);

  const onFadeIn = useCallback(() => {
    setFading(false);
    setSlide((prev) => ({ ...prev, data: slides[prev.index].data }));
    setTimeout(() => {
      setSlide((prev) => {
        const index = prev.index < slides.length - 1 ? prev.index + 1 : 0;
        return {
          ...prev,
          index,
          dark: slides[index].dark,
        };
      });
    }, 5000);
  }, []);

  const { data, dark } = slide;

  const ref = useDark(dark, onFadeIn, onFadeOut);

  return (
    <header className="header">
      <canvas className="canvas" ref={ref} />
      <animated.div style={props} className="display">
        <h1>{data.text}</h1>
        <h2>{data.subtext}</h2>
      </animated.div>
    </header>
  );
}

export default DarkSprings;
